import type en from "../en/admin";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  breadcrumb: "Fil d’Ariane",
  navAria: "Administration",
  navSectionsAria: "Sections de l’administration",
  reset: "Réinitialiser",
  any: "Tous",
  anyone: "Tout le monde",
  suspended: "Suspendu",
  suspendedReason: "Suspendu : {reason}",
  reasonRequired: "Un motif est obligatoire.",
  reasonAuditLabel: "Motif (consigné dans le journal d’audit)",
  reinstate: "Rétablir",
  system: "système",
  unknown: "inconnu",
  free: "Gratuit",
  perMonth: "{price}/mois",
  perYear: "{price}/an",
  healthOk: "OK",
  healthWarn: "Avertissement",
  healthError: "Erreur",
  slug: "Slug",
  currency: "Devise",
  sortOrder: "Ordre de tri",
  message: "Message",
  sending: "Envoi…",
  scope: "Portée",
  scope_platform: "Plateforme",
  scope_store: "Boutique",
  colStore: "Boutique",
  colOwner: "Propriétaire",
  colPlan: "Forfait",
  colRole: "Rôle",
  colUser: "Utilisateur",
  colWhen: "Date",
  colActor: "Auteur",
  colAction: "Action",
  colTarget: "Cible",
  colDetails: "Détails",
  colOrders: "Commandes",
  colProvider: "Prestataire",
  colAttempts: "Tentatives",
  colLastError: "Dernière erreur",
  colSubject: "Objet",
  products: "Produits",
  customers: "Clients",
  market: "Marché",
  joined: "Inscription",
  lastSignIn: "Dernière connexion",
  platformRole: "Rôle sur la plateforme",
  noAuditEntries: "Aucune entrée d’audit.",
  overviewTitle: "Vue d’ensemble de la plateforme",
  overviewDesc: "Instantané opérationnel de l’ensemble de la plateforme.",
  mUsers: "Utilisateurs",
  mUsersSub: "+{d30} sur 30 jours · {suspended} suspendus",
  mActiveMerchants: "Marchands actifs",
  mActiveMerchantsSub: "Propriétaires ayant une boutique publiée",
  mStores: "Boutiques",
  mLast30: "+{d30} sur 30 jours",
  mSuspendedStores: "Boutiques suspendues",
  mErrors24h: "Erreurs (24 h)",
  revenueTitle: "Revenus d’abonnement de la plateforme",
  revenueDesc: "Factures de plateforme payées uniquement (frais SaaS).",
  revenueEmpty: "Aucune facture de plateforme payée pour le moment.",
  colLast30: "30 derniers jours",
  colAllTime: "Depuis le début",
  gmvTitle: "Ventes des marchands (GMV), 30 derniers jours",
  gmvDesc: "Commandes payées hors mode test, nettes des remboursements, par devise de boutique.",
  gmvWarnStrong: "Les ventes des marchands ne sont pas des revenus de la plateforme.",
  gmvWarnBody: "Ces fonds sont versés directement sur les comptes de paiement des marchands.",
  gmvEmpty: "Aucune commande marchand payée au cours des 30 derniers jours.",
  colNetSales: "Ventes nettes",
  planDistTitle: "Répartition des forfaits",
  planDistDesc: "Abonnements actifs, en essai et en retard de paiement.",
  plansLink: "Forfaits →",
  supportQueueTitle: "File de support",
  openQueueLink: "Ouvrir la file →",
  mOpenPending: "Ouverts / en attente",
  storageInUse: "Stockage média utilisé : {size}",
  connTitle: "Connexions de paiement des marchands",
  connDesc: "Statut de connexion uniquement — aucun identifiant.",
  catalogueLink: "Catalogue →",
  connEmpty: "Aucune connexion de paiement marchand pour le moment.",
  recentStoresTitle: "Boutiques récentes",
  allStoresLink: "Toutes les boutiques →",
  noStoresYet: "Aucune boutique pour le moment.",
  usersMatching: "{n} comptes correspondants",
  usersMatching_one: "{n} compte correspondant",
  usersSearchPlaceholder: "Nom ou e-mail",
  colStoresOwned: "Boutiques possédées",
  unverified: "non vérifié",
  noUsersMatch: "Aucun utilisateur ne correspond à ces filtres.",
  metaUser: "Utilisateur",
  suspendUser: "Suspendre l’utilisateur",
  suspendUserTitle: "Suspendre {email} ?",
  suspendUserBody: "L’utilisateur est déconnecté partout et ne pourra plus se connecter tant qu’il n’aura pas été rétabli. Ses boutiques restent inchangées — suspendez-les séparément si nécessaire.",
  reinstateUser: "Rétablir l’utilisateur",
  reinstateUserTitle: "Rétablir {email} ?",
  reinstateUserBody: "L’utilisateur pourra de nouveau se connecter.",
  revokeSessions: "Révoquer les sessions",
  revokeSessionsCount: "Révoquer les sessions ({count})",
  revokeSessionsTitle: "Révoquer toutes les sessions ?",
  revokeSessionsBody: "L’utilisateur sera déconnecté sur tous ses appareils.",
  selfAccount: "Il s’agit de votre propre compte. Les changements de statut et de rôle doivent être effectués par un autre administrateur.",
  profile: "Profil",
  verified: "Vérifié",
  notVerified: "Non vérifié",
  locale: "Langue et région",
  sessions: "Sessions",
  sessionsActive: "{n} actives",
  roleChangeHint: "Changer le rôle déconnecte l’utilisateur.",
  roleSuperOnly: "Seuls les super-administrateurs peuvent modifier les rôles de la plateforme.",
  newRole: "Nouveau rôle",
  changeRole: "Changer le rôle",
  changeRoleConfirm: "Changer le rôle de cet utilisateur sur la plateforme ? Il sera déconnecté.",
  subscription: "Abonnement",
  billing: "Facturation",
  billingStripe: "Stripe (facturation de la plateforme)",
  billingNone: "Aucune / attribué",
  trialEnds: "Fin de l’essai",
  periodEnds: "Fin de la période",
  noSubscription: "Aucun abonnement enregistré pour le moment (le forfait par défaut s’applique).",
  assignPlanLabel: "Attribuer un forfait (sans paiement)",
  planInactive: "{name} (inactif)",
  assignPlan: "Attribuer le forfait",
  assignAs: "En tant que",
  assignAsActive: "actif",
  assignAsTrial: "essai",
  assignPlanConfirm: "Attribuer ce forfait sans encaisser de paiement ?",
  storesRoles: "Boutiques et rôles",
  notMember: "Membre d’aucune boutique.",
  recentActivity: "Activité récente",
  recentActivityDesc: "Entrées d’audit dont cet utilisateur est l’auteur.",
  noActivity: "Aucune activité enregistrée.",
  userSuspended: "Utilisateur suspendu et déconnecté.",
  userReinstated: "Utilisateur rétabli.",
  roleUpdated: "Rôle sur la plateforme mis à jour. Les sessions de l’utilisateur ont été révoquées.",
  planAssigned: "Forfait attribué.",
  sessionsRevoked: "Toutes les sessions ont été révoquées.",
  storesMatching: "{n} boutiques correspondantes",
  storesMatching_one: "{n} boutique correspondante",
  storesSearchPlaceholder: "Nom ou slug",
  colActiveProducts: "Produits actifs",
  colVerifiedDomains: "Domaines vérifiés",
  noStoresMatch: "Aucune boutique ne correspond à ces filtres.",
  metaStore: "Boutique",
  viewStorefront: "Voir la vitrine ↗",
  reinstateStore: "Rétablir la boutique",
  reinstateStoreTitle: "Rétablir {name} ?",
  reinstateStoreBody: "La boutique repasse en brouillon. Le marchand décide quand la publier de nouveau.",
  suspendStore: "Suspendre la boutique",
  suspendStoreTitle: "Suspendre {name} ?",
  suspendStoreBody: "La vitrine est mise hors ligne et le paiement est désactivé. Les données, commandes et connexions de paiement restent intactes.",
  identity: "Identité",
  publicUrl: "URL publique",
  businessType: "Type d’activité",
  theme: "Thème",
  ownerPlan: "Propriétaire et forfait",
  ownerStatus: "Statut du propriétaire",
  effectivePlan: "Forfait effectif",
  contactEmail: "E-mail de contact",
  domains: "Domaines",
  platformAddressOnly: "Adresse de la plateforme uniquement.",
  primary: "principal",
  paymentConnections: "Connexions de paiement",
  paymentConnectionsDesc: "Statut uniquement. Les identifiants ne sont jamais chargés ni affichés dans l’espace d’administration.",
  colCheckout: "Paiement",
  colMode: "Mode",
  mode_test: "Test",
  mode_live: "Production",
  colLastVerified: "Dernière vérification",
  off: "Désactivé",
  noPaymentMethods: "Aucun moyen de paiement configuré.",
  storeAuditDesc: "Les 25 entrées les plus récentes pour cette boutique.",
  storeSuspended: "Boutique suspendue.",
  storeReinstated: "Boutique rétablie en brouillon — le marchand peut la publier de nouveau.",
  plansDesc: "Forfaits d’abonnement de la plateforme. Abaisser une limite ne supprime jamais de données marchand — les marchands au-delà d’une limite conservent leurs données mais ne peuvent plus en ajouter.",
  newPlan: "Nouveau forfait",
  crumbNew: "Nouveau",
  metaEditPlan: "Modifier le forfait",
  colFlags: "Indicateurs",
  colSubscribers: "Abonnés",
  trialBadge: "essai de {n} jours",
  limitsSummary: "{stores} boutiques · {products} produits · {staff} employés · {domains} domaines · {storage}",
  flagDefault: "par défaut",
  flagActive: "actif",
  flagInactive: "inactif",
  flagPublic: "public",
  flagHidden: "masqué",
  flagStripePrice: "Prix Stripe",
  subscribersCount: "{n} abonnés",
  subscribersCount_one: "{n} abonné",
  planCreated: "Forfait créé.",
  planChangesInfo: "Les modifications s’appliquent aux {n} abonnés actuels. Abaisser une limite ne supprime jamais de données marchand ; les changements de prix ne modifient pas les abonnements Stripe existants tant qu’ils ne sont pas modifiés dans Stripe.",
  planChangesInfo_one: "Les modifications s’appliquent à l’abonné actuel ({n}). Abaisser une limite ne supprime jamais de données marchand ; les changements de prix ne modifient pas les abonnements Stripe existants tant qu’ils ne sont pas modifiés dans Stripe.",
  planSaved: "Forfait enregistré. Les données marchand existantes ne sont pas affectées par les changements de limites.",
  planCode: "Code",
  planCodeHint: "Lettres minuscules, chiffres, - et _. Utilisé dans les URL et la facturation.",
  prices: "Prix",
  monthlyPrice: "Prix mensuel",
  monthlyPriceHint: "Décimal, ex. 29.00",
  yearlyPrice: "Prix annuel",
  trialDays: "Jours d’essai",
  limits: "Limites",
  limitsHint: "Abaisser une limite ne supprime jamais de données marchand — les marchands au-delà conservent ce qu’ils ont mais ne peuvent plus rien ajouter.",
  limitStores: "Boutiques",
  limitProducts: "Produits / boutique",
  limitStaff: "Employés / boutique",
  limitDomains: "Domaines personnalisés",
  limitStorage: "Stockage (Mo)",
  features: "Fonctionnalités",
  feature_discounts: "Codes de réduction",
  feature_digital_products: "Produits numériques",
  feature_advanced_analytics: "Statistiques avancées",
  feature_abandoned_cart: "Relances de paniers abandonnés",
  feature_reviews: "Avis produits avec modération",
  feature_custom_domains: "Domaines personnalisés",
  feature_team: "Comptes d’équipe et rôles",
  feature_all_themes: "Tous les thèmes, y compris premium",
  feature_priority_support: "Support prioritaire",
  visibilityBilling: "Visibilité et facturation",
  public: "Public",
  publicHint: "Affiché sur la page des tarifs et dans le sélecteur de forfait des marchands.",
  defaultPlanActiveHint: "Le forfait par défaut doit rester actif.",
  inactivePlanHint: "Les forfaits inactifs ne peuvent pas être choisis ; les abonnés existants les conservent.",
  stripePriceMonthly: "ID de prix Stripe (mensuel)",
  stripePriceYearly: "ID de prix Stripe (annuel)",
  stripePriceHint: "price_… du compte Stripe de la plateforme. Laissez vide pour utiliser une tarification intégrée.",
  createPlan: "Créer le forfait",
  savePlan: "Enregistrer le forfait",
  paymentsTitle: "Intégrations de paiement",
  paymentsDesc: "Les intégrations de paiement proposées aux marchands par la plateforme, et la façon dont les marchands les utilisent.",
  howTitle: "Fonctionnement de la disponibilité des paiements",
  step1Title: "1 · Disponible sur la plateforme",
  step1Body: "Le commutateur de cette page. Détermine si les marchands peuvent configurer l’intégration. Une restriction exige un motif visible par les marchands.",
  step2Title: "2 · Configuration opérationnelle",
  step2Body: "Paramètres de plateforme requis par certains moyens, p. ex. l’application OAuth Stripe Connect et son secret de webhook (variables d’environnement). Sans Connect, les marchands peuvent toujours utiliser leurs propres clés API Stripe.",
  step3Title: "3 · Connexion du compte marchand",
  step3Body: "Chaque marchand connecte son propre compte prestataire. Les fonds sont versés au marchand, jamais à la plateforme.",
  step4Title: "4 · Activation au niveau de la boutique",
  step4Body: "Le marchand active ou désactive un moyen connecté pour son checkout.",
  restrictWarning: "Restreindre un prestataire ne déplace, ne redirige ni n’encaisse jamais les paiements d’un marchand, et ne connecte ni ne modifie jamais le compte d’un marchand. Cela limite uniquement l’utilisation future de cette intégration.",
  catalogueTitle: "Catalogue des prestataires",
  colImplemented: "Implémenté",
  colOperational: "Configuration opérationnelle",
  colConnected: "Connectés",
  colEnabledCheckout: "Activés au paiement",
  colErrors: "Erreurs",
  colAvailability: "Disponibilité sur la plateforme",
  providerKind_online: "En ligne",
  providerKind_offline: "Hors ligne",
  method_oauth: "OAuth",
  method_api_keys: "clés API",
  method_offline: "hors ligne",
  notYetSupported: "Pas encore pris en charge",
  connectOauth: "OAuth Connect :",
  connectWebhook: "Webhook Connect :",
  configured: "configuré",
  notConfigured: "non configuré",
  configuredCap: "Configuré",
  notConfiguredCap: "Non configuré",
  noneNeeded: "Aucune requise",
  perMerchant: "Par marchand (identifiants propres)",
  available: "Disponible",
  restricted: "Restreint",
  platformBilling: "Facturation de la plateforme",
  platformBillingDesc: "La facturation des abonnements SaaS propre à Storelancer.",
  billingApiKey: "Clé API de facturation",
  billingKeyHint: "Les forfaits payants ne peuvent être attribués que par les administrateurs tant que {env} n’est pas défini.",
  billingWebhook: "Webhook de facturation",
  secretConfigured: "Secret configuré",
  secretNotConfigured: "Secret non configuré",
  webhookEndpoint: "Point de terminaison du webhook",
  merchantPaymentsNote: "Les paiements des boutiques utilisent toujours le compte prestataire connecté propre à chaque marchand.",
  restrict: "Restreindre…",
  restrictionReason: "Motif de la restriction (visible par les marchands)",
  restrictProvider: "Restreindre le prestataire",
  makeAvailable: "Rendre disponible",
  liftRestriction: "Lever la restriction",
  providerAvailable: "Prestataire disponible sur la plateforme.",
  providerRestricted: "Prestataire restreint. Les paiements marchands existants n’ont pas été redirigés.",
  ticketsByStatus: "{n} tickets · {status}",
  ticketsByStatus_one: "{n} ticket · {status}",
  ticketsOpenPending: "{n} tickets ouverts ou en attente, les plus urgents en premier",
  ticketsOpenPending_one: "{n} ticket ouvert ou en attente, les plus urgents en premier",
  statusOpenPending: "Ouverts + en attente",
  pendingAwaiting: "En attente (réponse du demandeur)",
  ticketStatus_open: "Ouvert",
  ticketStatus_pending: "En attente",
  ticketStatus_resolved: "Résolu",
  ticketStatus_closed: "Fermé",
  priority: "Priorité",
  priority_low: "Basse",
  priority_normal: "Normale",
  priority_high: "Haute",
  priority_urgent: "Urgente",
  category_general: "Question générale",
  category_billing: "Forfait et facturation",
  category_payments: "Paiements et versements",
  category_domains: "Domaines",
  category_technical: "Problème technique",
  category_account: "Compte et connexion",
  assignee: "Responsable",
  assignedToMe: "Qui me sont attribués",
  unassigned: "Non attribué",
  requester: "Demandeur",
  colCategory: "Catégorie",
  guest: "invité",
  staff: "Équipe",
  queueEmpty: "La file est vide.",
  ticket: "Ticket",
  ticketDesc: "n° {number} · {category} · ouvert le {date}",
  conversation: "Conversation",
  badgeInternalNote: "note interne",
  badgeStaffReply: "réponse de l’équipe",
  badgeRequester: "demandeur",
  respond: "Répondre",
  account: "Compte",
  viewUser: "Voir l’utilisateur",
  guestNoAccount: "Invité (sans compte)",
  replyToRequester: "Répondre au demandeur",
  addInternalNote: "Ajouter une note interne",
  replyHint: "Les réponses sont envoyées par e-mail au demandeur. Les notes internes ne sont visibles que par l’équipe.",
  updateTicket: "Mettre à jour le ticket",
  writeMessageFirst: "Rédigez d’abord un message.",
  internalNoteAdded: "Note interne ajoutée.",
  replySent: "Réponse envoyée par e-mail au demandeur.",
  ticketUpdated: "Ticket mis à jour.",
  contentTitle: "Contenu de la plateforme",
  contentDesc: "Annonces, FAQ, articles d’aide et pages légales affichés sur le site public. Les pages légales définies ici remplacent les modèles intégrés (slugs : terms, privacy, cookies, acceptable-use).",
  contentDeleted: "Contenu supprimé.",
  tab_announcement: "Annonces",
  tab_faq: "FAQ",
  tab_doc: "Documentation",
  tab_legal: "Mentions légales",
  kind_announcement: "Annonce",
  kind_faq: "FAQ",
  kind_doc: "Article de documentation",
  kind_legal: "Page légale",
  colState: "État",
  colOrder: "Ordre",
  publicLink: "Lien public",
  viewExternal: "Voir ↗",
  noContent: "Aucun contenu pour le moment.",
  newContent: "Nouveau contenu",
  metaEditContent: "Modifier le contenu",
  deleteContentTitle: "Supprimer « {title} » ?",
  deleteLegalBody: "La page publique reviendra au modèle intégré.",
  slugHint: "Pages légales : terms, privacy, cookies, acceptable-use",
  body: "Contenu",
  bodyHint: "Texte brut. Utilisez « ## » pour les titres, « - » pour les listes à puces et des lignes vides entre les paragraphes. Le HTML n’est pas interprété.",
  contentCreated: "« {title} » créé.",
  healthChecked: "Vérifié le {time}. Les valeurs de configuration et les secrets ne sont jamais affichés ici.",
  colCheck: "Vérification",
  colDetail: "Détail",
  eventsTitle: "Événements système récents",
  eventsDesc: "Les 50 derniers événements des workers, des webhooks et de l’application.",
  colLevel: "Niveau",
  colSource: "Source",
  noEvents: "Aucun événement système enregistré.",
  failedJobsTitle: "Tâches d’arrière-plan en échec",
  failedJobsDesc: "Tâches ayant épuisé leurs tentatives.",
  colFinished: "Terminée",
  noFailedJobs: "Aucune tâche en échec.",
  auditDesc: "Actions sensibles sur la plateforme et les boutiques, les plus récentes en premier.",
  auditSearchLabel: "Action, e-mail de l’auteur ou ID de la cible",
  auditSearchPlaceholder: "ex. {example}",
  storeLink: "boutique",
  noAuditMatch: "Aucune entrée d’audit ne correspond.",
  paginationAria: "Pagination",
  pageN: "Page {page}",
  newer: "Plus récentes",
  older: "Plus anciennes",
  emailsDesc: "Les 100 derniers e-mails sortants — métadonnées uniquement. Le contenu des messages n’est jamais affiché car il peut contenir des liens de réinitialisation de mot de passe ou de téléchargement.",
  colQueued: "Mis en file",
  colTo: "Destinataire",
  colTemplate: "Modèle",
  loggedNoSmtp: "Journalisé (pas de SMTP)",
  noEmails: "Aucun e-mail pour le moment.",
  trialBadge_one: "essai de {n} jour",
};

export default fr;
